module.exports = "<ion-app>\n    <ion-router-outlet></ion-router-outlet>\n</ion-app>\n"